// Country
export const DEFAULT_COUNTRY = "IN";

// State
export const DEFAULT_STATE = "TN";
